import { render, staticRenderFns } from "./LimitsTab.vue?vue&type=template&id=8225ae5e"
import script from "./LimitsTab.vue?vue&type=script&lang=js"
export * from "./LimitsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports